import React from 'react'
import ViewLabelValueField from './frontend_components/ViewLabelValueField'
import useMediaQuery from '../hooks/useMediaQuery'
import VisDiv from './frontend_components/VisDiv'

const DeviceFamilyReport = ({register, registerTemplate}) => {

  const families = !Array.isArray(registerTemplate?.devices) ? [] : registerTemplate?.devices?.map?.((family)=> {

    const doc = {
      label: family?.label,
      _id: family?._id
    }
    return doc
  })

  const testFunction=()=>{
    console.log("DEVICE FAMILY REPORT", register, registerTemplate)
  }
  const mediumScreen = useMediaQuery("(min-width: 925px)")
  const ipadScreen = useMediaQuery("(min-width: 725px)")

  const labelValueDistance = () => {
      if(mediumScreen) return 4
      if(ipadScreen) return 2
      return 1
  } 


  return (
    <div>
      <h3 onClick={testFunction}> REPORT FAMIGLIE</h3>
      <VisDiv style={{textAlign:"left"}}>
        {
         !Array.isArray(families) ? [] : families?.map?.((item, index)=>{
            const nDevicesWithFamilies = !Array.isArray(register?.devices) ? [] : register?.devices?.filter?.((x)=>x?.status !== "ARCHIVIATO" && x?.status !== "DA FORNIRE" && x?.templateDevice?._ref == item?._id)?.length
            return (
            <VisDiv key={index} rules={[nDevicesWithFamilies > 0]} >
              <ViewLabelValueField label={item?.label ? item?.label : "ALTRO"} value={nDevicesWithFamilies} highlight={"blue"} labelValueDistance = {labelValueDistance()}/>
            </VisDiv>
            )
          })
        }
       
      </VisDiv>
      

    </div>
  )
}

export default DeviceFamilyReport
